import { useRef, useEffect } from "react";
import { questions } from "../../Trilogic/QuestionsRoute/questionList";
import Chart from "react-apexcharts";
import './style.css';

export default function QuestionSection({ numero, responses, className, onChartReady }) {
  const chartRef = useRef(null);

  const dados = {
    discordoTotalmente: responses["Discordo totalmente"]?.count || 0,
    discordo: responses["Discordo"]?.count || 0,
    nem: responses["Nem discordo, nem concordo"]?.count || 0,
    concordo: responses["Concordo"]?.count || 0,
    concordoTotalmente: responses["Concordo totalmente"]?.count || 0,
  };

  const labels = [
    "Discordo totalmente",
    "Discordo",
    "Indiferente",
    "Concordo",
    "Concordo totalmente"
  ];

  useEffect(() => {
    // Espera o gráfico ser renderizado para capturar a imagem
    if (onChartReady && chartRef.current) {
      //Apex mostra com chartRef.current.chart
      setTimeout(() => {
        const chartObj = chartRef.current?.chart;
        if (chartObj && chartObj.dataURI) {
          chartObj.dataURI().then(({ imgURI }) => {
            onChartReady(numero, imgURI);
          });
        }
      }, 500); // Tempo de espera para garantir que o gráfico esteja pronto
    }
    // Apenas roda quando as respostas mudarem
    // eslint-disable-next-line
  }, [responses]);

  return (
    <div className={className ? className : "grafico"}>
      <h2 style={{ textAlign: "left" }}>{numero}. {questions[numero]}</h2>
      <Chart
        ref={chartRef}
        type="bar"
        options={{
          chart: {
            id: "bar-chart",
            type: "bar"
          },
          xaxis: {
            categories: labels
          },
          plotOptions: {
            bar: {
              horizontal: true,
              distributed: true
            }
          },
          colors: [
            "#008FFB", // Discordo totalmente
            "#00E396", // Discordo
            "#FEB019", // Nem discordo, nem concordo
            "#FF4560", // Concordo
            "#775DD0"  // Concordo totalmente
          ]
        }}
        series={[
          {
            name: "Respostas",
            data: [
              dados.discordoTotalmente,
              dados.discordo,
              dados.nem,
              dados.concordo,
              dados.concordoTotalmente
            ]
          }
        ]}
        width="100%"
      />
      <hr />
    </div>
  );
}